import React from 'react';
import { FaAward, FaGraduationCap } from 'react-icons/fa';
// import { FiUser } from 'react-icons/fi';
import { VscFolderLibrary } from 'react-icons/vsc';

import './about.css';
import Me from '../../assets/me-about.jpg';

const renderCard = (Icon, title, info) => (
  <article className="about__card">
    <Icon className="about__icon" />
    <h5>{title}</h5>
    <small>{info}</small>
  </article>
);

const About = () => {
  return (
    <section id="about">
      <h5>Get to Know</h5>
      <h2>About Me</h2>

      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={Me} alt="Danial's Avatar" />
          </div>
        </div>

        <div className="about__content">
          <div className="about__cards">
            {renderCard(FaAward, 'Experience', 'Feash Graduate')}
            {/* {renderCard(FiUser, 'Clients', '10+ Worldwide')} */}
            {renderCard(FaGraduationCap, 'Education', 'BCS - 4 Year')}
            {renderCard(VscFolderLibrary, 'Projects', '10+ MERN')}
            {/* Ecommerce - JWT/Social Auth - Web Scraper */}
          </div>

          <p>
            <span>MERN Stack Developer</span> studying at Comsats University
            Islamabad, Lahore Campus in Final Year. A self-motivated and
            energetic student. Exited to be at the preliminary stages of my
            career as a Full Stack Developer. I want to be part of a respectable
            institute not only to improve my knowledge but also to polish my
            skills with hard work and dedication. I am adventurous, courageous,
            ambitious, and trustworthy. .
          </p>
          {/* <p>
            <span>MERN Stack Developer</span> with Bachelor of Science in
            Computer Science from Comsats University Islamabad, Lahore Campus. A
            self-motivated and energetic student. Exited to be at the
            preliminary stages of my career as a Full Stack Developer. I want to
            be part of a respectable institute not only to improve my knowledge
            but also to polish my skills with hard work and dedication. I am
            adventurous, courageous, ambitious, and trustworthy.
          </p> */}

          <a href="#contact" className="btn btn-primary">
            Let's Talk
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
